export default __webpack_public_path__ + "static/media/safari.2df9588b.png";